import { render, staticRenderFns } from "./InstanceEditCards.vue?vue&type=template&id=1339f2be&"
import script from "./InstanceEditCards.vue?vue&type=script&lang=js&"
export * from "./InstanceEditCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports